import React, { useState, useRef } from 'react';
import useVisibleCount from './hooks/useVisibleCount';
import { View,TouchableOpacity, StyleSheet, Pressable } from 'react-native';
import { Icons, PositionModal, Tooltip, Typography } from '@hmsexp/component-library';

const FilterSummary = ({ config, summary, selectedFilterKeys, setOpen }) => {
  const { visibleCount, containerRef, measureRef } = useVisibleCount(summary);
  const [showHidden, setShowHidden] = useState(false);
  const moreRef = useRef(null);
  const [parentPositions, setParentPositions] = useState(null);
  
  const handleMoreOpen = () => {
    setShowHidden(true);
    moreRef.current.measure((fx, fy, width, height, px, py) => {
      setParentPositions({ x: px, y: py + 3, w: width, h: height });
    });
  };
  const keys = Object.keys(summary);

  const visibleKeys = keys.slice(0, visibleCount);
  const hiddenKeys = keys.slice(visibleCount);
  const hiddenCount = hiddenKeys.length;

  return (
    <Pressable
      style={styles.summaryRow}
      ref={containerRef}
      onPress={() => {
        setOpen(prev => !prev);
        window.scrollTo({
          top: 0,
          behavior: 'auto'
        });
      }}>
      {visibleKeys.length > 0 ? (
        visibleKeys.map(key => {
          const filter = config.find(f => f.key === key);
          if (!filter) return null;
          return (
            <Tooltip
              key={key}
              aretPosition='center'
              content={summary[key]}
              position='bottom'
              strictPosition
              style={{ container: { width: 250, zIndex: 100 } }}
              withCaret>
              <Pressable
                onPress={() => {
                  setOpen(prev => !prev);
                }}>
                <View style={styles.summaryItem}>
                  <Typography fontWeightType='regular' variant='body2' textProps={{
                    style: styles.summaryLabel,
                    numberOfLines: 1,
                    ellipsizeMode: "tail"
                  }}>{filter.label}</Typography>
                  <Typography fontWeightType='regular' variant='body1' textProps={{ style: styles.summaryValue, numberOfLines: 1, ellipsizeMode: "tail" }} >
                    {summary[key]}
                  </Typography>
                </View>
              </Pressable>
            </Tooltip>
          );
        })
      ) : (
        <Typography textProps={{style:styles.emptyText}}>No filters applied</Typography>
      )}

      {hiddenCount > 0 && (
        <TouchableOpacity onPress={() => handleMoreOpen()} ref={moreRef}>
          <Typography textProps={{style:styles.moreText}}>+{hiddenKeys?.filter(key=>config?.find(f => f.key === key))?.length} more</Typography>
        </TouchableOpacity>
      )}

      <PositionModal visible={showHidden} outsideClick={() => setShowHidden(false)} parentPositions={parentPositions}>
        <View style={styles.hiddenContainer}>
          {hiddenKeys.map(key => {
            const filter = config.find(f => f.key === key);
            if (!filter) return null;
            return (
              <View key={key} style={styles.hiddenItem}>
                <Typography fontWeightType='regular' variant='body2' textProps={{ style: styles.summaryLabel ,
                  numberOfLines:1,
                  ellipsizeMode:"tail"
                }}>{filter.label}</Typography>
                <Typography fontWeightType='regular' variant='body1' textProps={{ style: styles.summaryValue ,numberOfLines:1,ellipsizeMode:"tail"}}>{summary[key]}</Typography>
              </View>
            );
          })}
        </View>
      </PositionModal>

      <TouchableOpacity style={styles.iconButton} onPress={() => setOpen(prev => !prev)}>
        <Icons.SlidersIcon size='L' color='#2d77d0' />
      </TouchableOpacity>

      <View ref={measureRef} style={styles.hiddenMeasureContainer}>
        {keys.map(key => {
          const filter = config.find(f => f.key === key);
          if (!filter) return null;
          return (
            <View key={key} style={styles.summaryItem}>
              <Typography fontWeightType='regular' variant='body2' textProps={{ style: styles.summaryLabel,numberOfLines:1,ellipsizeMode:"tail" }}>{filter.label}</Typography>
              <Typography fontWeightType='regular' variant='body1' textProps={{ style: styles.summaryValue,numberOfLines:1,ellipsizeMode:"tail" }} >
                {summary[key]}
              </Typography>
            </View>
          );
        })}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  summaryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    zIndex: 100,
    paddingVertical: 8,
    paddingHorizontal: '2%',
    flexWrap: 'nowrap',
    position: 'relative'
  },
  summaryItem: { marginRight: 20 },
  summaryLabel: { color: '#6b7280' },
  summaryValue: { color: '#111827', maxWidth: 160 },
  moreText: { color: '#2563eb', fontWeight: '500', marginRight: 12 },
  iconButton: { marginLeft: 'auto', transform: [{ rotate: '90deg' }] },
  emptyText: { color: '#9ca3af' },
  hiddenContainer: {
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    padding: 10,
    marginTop: 4,
    zIndex: 10,
    width: 200
  },
  hiddenItem: {
    marginBottom: 8
  },
  hiddenMeasureContainer: {
    position: 'absolute',
    visibility: 'hidden',
    opacity: 0,
    zIndex: -1,
    flexDirection: 'row',
    pointerEvents: 'none',
    top: -9999,
    left: -9999
  }
});

export default FilterSummary;
